/**
 * Get the index of a node in its parent
 * @param {HTMLElement} node
 * @returns {number}
 */
export function getNodeIndex(node) {
  return Array.from(node.parentNode.children).indexOf(node);
}
